import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useSwipeable} from 'react-swipeable';
import {osName} from 'react-device-detect';
import moment from 'jalali-moment';

import {Splide, SplideSlide} from '@splidejs/react-splide';
import GlobalConst from '../../../common/global-const';

import {Offcanvas, Button, Container} from 'react-bootstrap';

import * as IconFi from 'react-icons/fi';

import './Offers.scss'

const OffcanvasOffers = props => {
    const navigate = useNavigate()

    const data = props.data;

    const slideshowOptions = {...GlobalConst.splide, type: data?.photos?.length > 1 ? 'loop' : '', drag: data?.photos?.length > 1, arrows: data?.photos?.length > 1}

    // --------------------------------------------------------------------------------------------------- show and hide

    const handlePopstate = () => {

        if (document.querySelectorAll('.offcanvas').length < 2)
            window.removeEventListener('popstate', handlePopstate)

        props.onHide()

    }

    const onShowHandler = () => {

        document.querySelector('#offcanvasOffers > div').style.paddingRight = document.querySelector('body').style.paddingRight

        navigate('#offcanvasOffers')
        window.addEventListener('popstate',  handlePopstate);

    }

    const onHideHandler = () => {

        navigate(-1)

    }

    const swipe = useSwipeable({
        onSwiping: (data) => {

            if (data.deltaY > 0 && data.deltaY < data.event.target.closest('.offcanvas').offsetHeight)
                data.event.target.closest('.offcanvas').style.transform = `translateY(${data.deltaY}px)`

        },
        onSwiped: (data) => {

            if (data.velocity > .9) {

                data.event.target.closest('.offcanvas').style.transform = `translateY(100%)`
                onHideHandler()

            } else {

                let h = data.event.target.closest('.offcanvas').offsetHeight
                let translateY = getComputedStyle(data.event.target.closest('.offcanvas')).transform.match(/matrix.*\((.+)\)/)[1].split(', ')[5]

                if (translateY > h / 2) {

                    data.event.target.closest('.offcanvas').style.transform = `translateY(100%)`
                    onHideHandler()

                } else data.event.target.closest('.offcanvas').style.transform = ''
            }

        }
    });

    // -----------------------------------------------------------------------------------------------------------------

    const renderHref = () => {

        if (osName === 'Android') {

            return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${data.offer}&dates=${moment.from(data.start_at, 'fa').format('YYYYMMDD')}/${moment.from(data.end_at, 'fa').format('YYYYMMDD')}&location=Kish Island, Iran`;

        } else if(osName === 'iOS') {

            return `data:text/calendar;charset=utf8,BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
DTSTART:${moment.from(data.start_at, 'fa').format('YYYYMMDD')}
DTEND:${moment.from(data.end_at, 'fa').format('YYYYMMDD')}
SUMMARY:${data.offer}
LOCATION:Kish Island, Iran
END:VEVENT
END:VCALENDAR`

        } else {
            return '#'
        }

    }

    // -----------------------------------------------------------------------------------------------------------------

    // از کلاس fixed-bottom استفاده شد تا padding-right ایجاد گردد
    return (
        <Offcanvas id="offcanvasOffers" {...props} placement="bottom" onHide={onHideHandler} onShow={onShowHandler} className="ltr fixed-bottom">
            <div className="w-100vw">
                <Container fluid="lg" className="px-0 rtl">
                    {
                        data && (
                            <>
                                <Offcanvas.Header className="position-sticky top-0 flex-column flex-md-row">
                                    <Button variant="link" className="pt-1 pb-3 align-self-stretch d-flex justify-content-center d-md-none minimize" onClick={onHideHandler} onTouchStart={e => e.target.closest('.offcanvas').classList.add('swiping')} onTouchEnd={e => e.target.closest('.offcanvas').classList.remove('swiping')} {...swipe}/>
                                    <Offcanvas.Title>{data.offer}</Offcanvas.Title>
                                    <Button variant="link" className="text-reset border-0 btn-icon d-none d-md-inline-flex" aria-label="Close" onClick={onHideHandler}><IconFi.FiX size={24} className="m-2 sw-1"/></Button>
                                </Offcanvas.Header>
                                <Offcanvas.Body className="py-0 overflow-visible">
                                    {
                                        data.photos?.length ? (
                                            <div className="bg-white bg-opacity-4 mb-4 slideshow">
                                                <Splide options={slideshowOptions}>
                                                    {
                                                        data.photos.map((item, index) => {
                                                            return (
                                                                <SplideSlide key={index}>
                                                                    <div className="h-100 d-flex justify-content-center align-items-center">
                                                                        <figure className="mb-0 filter-warm">
                                                                            <span className="filter-level"/>
                                                                            <img src={`${GlobalConst.cdn}${item.path}`} alt="" className="img-fluid"/>
                                                                        </figure>
                                                                    </div>
                                                                </SplideSlide>
                                                            )
                                                        })
                                                    }
                                                </Splide>
                                            </div>
                                        ) : (
                                            <></>
                                        )
                                    }
                                    <div className="fs-5 ls-1 lh-1 pb-2">{data.start_at}<span className="ls-normal fs-6 px-1"> تا </span>{data.end_at}</div>
                                    <div dangerouslySetInnerHTML={{__html: data.description}}/>
                                    <div className="position-sticky bottom-0 py-2 pb-md-4 pb-xl-5 d-grid offcanvas-btn">
                                        <Button href={renderHref()} target="_blank" variant="primary" className="offcanvas-btn">افزودن به تقویم</Button>
                                    </div>
                                </Offcanvas.Body>
                            </>
                        )
                    }
                </Container>
            </div>
        </Offcanvas>
    )
}

export default OffcanvasOffers;